import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { withStyles } from "@material-ui/core";

export default withStyles((theme) => ({
  root: {
    padding: 0,
    display: "block"
  }
}))(MuiAccordionDetails);
